import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../config/emotion";

export const listsContainerCss = css`
  display: flex;
  flex-direction: row;
`;

export const columnCss = css`
  display: flex;
  flex-direction: column;
`;

export const forGroupColumnCss = css`
  margin-right: 30px;
`;

export const columnHeaderCss: ThemedCssCreator = (theme) => css`
  color: ${theme.colors.secondaryColor};
  text-align: center;
  font-weight: bold;
`;

export const optionListContainerCss = css`
  flex-grow: 1;
`;

export const arrowsContainerCss = css`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const buttonContainerCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 20px;
`;

export const containerCss = css`
  width: fit-content;
`;

export const noOptionsFoundCss = css`
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: gray;
  margin-top: 5px;
`;
